module.exports = __webpack_public_path__ + "img/2019pigc.3833dc75.png";